import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import routerReducer from './RouterReducer';
import app from './AppReducer';
import InvitationReducer from './InvitationReducer';
import intlReducer from './IntlReducer';

export default combineReducers({
  app,
  invitations: InvitationReducer,
  router: routerReducer,
  form: formReducer,
  intl: intlReducer,
});
